// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2XGQ8","title":"AfterFrontImage_title__3Z8qW"};